<script lang="ts">import imgAvatar from "./images/avatar.png";
import MaskInput from "svelte-input-mask/MaskInput.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { Readable } from "svelte/store";
import { findSourceStore } from "../../../utilities";
export let element;
export let sources;
let srcStore;
let data;
let name;
let email;
$: srcStore = findSourceStore($sources, 'YinzCamSignonProfileSegment');
$: data = (srcStore && $srcStore) ? $srcStore : null;
$: email = data === null || data === void 0 ? void 0 : data.Email;
$: name = (data === null || data === void 0 ? void 0 : data.FirstName) + " " + (data === null || data === void 0 ? void 0 : data.LastName);
</script>

<div class="profile-card">
  <div class="profile">
    <button type="button" class="button">Edit</button>
    <div class="avatar-wrapper">
      <img src={imgAvatar} alt="avatar" />
    </div>
    <button type="button" class="button">Sign Out</button>
  </div>
  <div class="name">{name}</div>
  <div class="bulls-representative">
    <h3>MY BULLS REPRESENTATIVE</h3>
    <div class="input-form">
      <div class="avatar-container">
        <img src={imgAvatar} alt="avatar" />
        <div class="name-container">
          <div class="name">{name}</div>
          <div class="comment">Bulls Representative</div>
        </div>
      </div>
      <div class="icon-input">
        <i class="f7-icons">phone_circle_fill</i>
        <MaskInput alwaysShowMask maskChar="x" mask="(000) 000-0000" />
      </div>
      <div class="line" />
      <div class="icon-input">
        <i class="f7-icons">envelope_circle_fill</i>
        <input type="text" bind:value={email} />
      </div>
    </div>
    <div class="button-container">
      <button type="button" class="button">Manage My Account</button>
      <button type="button" class="button">Season Ticket Portal</button>
    </div>
  </div>
</div>

<style type="text/scss">*, *::after, *::before {
  box-sizing: border-box;
}

.profile-card {
  width: 100%;
  height: 100%;
  background-image: url("./images/h-15-bg@3x.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding: 14px 0 0 0;
}

.profile {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.profile button {
  background: black;
  color: white;
  width: 90px;
  height: 30px;
  border: none;
  margin: 0 0 15px 0;
}

.profile .avatar-wrapper {
  margin: 0 14px;
  padding: 4px;
  border-radius: 50%;
  width: 110px;
  height: 110px;
  border: 2px solid #C60033;
}

.profile .avatar-wrapper img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.name {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin: 8px 0 0 0;
}

.bulls-representative {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 11px;
  margin: 10px 0 0 0;
}

.bulls-representative h3 {
  width: 100%;
  font-family: Druk;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: 0.5px;
  color: #000;
  margin: 0;
}

.bulls-representative .input-form {
  padding: 9px 23px 7px 12px;
  border: solid 1px #e5e5e5;
  margin: 9px 0 14px 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.bulls-representative .input-form .avatar-container {
  display: flex;
  align-items: center;
  margin: 0 0 11px 0;
}

.bulls-representative .input-form .avatar-container img {
  width: 58px;
  height: 58px;
  display: block;
  border-radius: 50%;
}

.bulls-representative .input-form .avatar-container .name-container {
  margin: 0 0 0 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.bulls-representative .input-form .avatar-container .name-container .name {
  font-family: 'SF UI Display';
  font-size: 13.9px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;
}

.bulls-representative .input-form .avatar-container .name-container .comment {
  font-family: 'SF UI Display';
  font-size: 12.7px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}

.bulls-representative .input-form .line {
  background: #d7d7d7;
  height: 1px;
  margin: 8px 0px 8px 40px;
}

.bulls-representative .input-form .icon-input {
  display: flex;
  align-items: center;
}

.bulls-representative .input-form .icon-input i {
  color: #C60033;
  margin: 0 23px 0 0;
  font-size: 40px;
}

.bulls-representative .input-form .icon-input :global(input) {
  font-family: 'SF UI Display';
  font-size: 13.9px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;
  border: none;
}

.bulls-representative .button-container {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  width: 100%;
}

.bulls-representative .button-container button {
  border: none;
  background-color: #c60033;
  width: 100%;
  height: 38px;
  text-transform: none;
  font-family: 'SF UI Display';
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.71;
  letter-spacing: normal;
  color: #fff;
  margin: 0 0 8px 0;
}

.bulls-representative .button-container button:last-child {
  margin-bottom: 0;
}</style>
